module.exports = __webpack_public_path__ + "static/media/IMG_2218.e186cb62.JPG";